import RadioMultiQuestionsToTable from './RadioMultiQuestionsToTable';
export default RadioMultiQuestionsToTable;
